/* Dual-brand storefront: behaviour for the "Switch to …" controls.
   Loaded only when the dual-brand feature is active (see sections/header.liquid).

   - Keeps the current query string (variant, search terms, filters) on pages whose
     path exists on both domains (links marked data-preserve-query).
   - Keeps Shopify's preview_theme_id while previewing an unpublished theme, so the
     other domain opens the same unpublished theme.
   - Carts are stored per domain. When the cart has items, asks before leaving
     instead of silently leaving the cart behind. Nothing is deleted either way:
     the cart stays on this domain. */
(function () {
  if (window.BrandSwitchLoaded) return;
  window.BrandSwitchLoaded = true;

  function buildUrl(link) {
    var url;
    try {
      url = new URL(link.getAttribute('data-base-href') || link.getAttribute('href'), window.location.href);
    } catch (error) {
      return null;
    }

    if (link.hasAttribute('data-preserve-query')) {
      new URLSearchParams(window.location.search).forEach(function (value, key) {
        if (!url.searchParams.has(key)) url.searchParams.append(key, value);
      });
    }

    var theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.id && theme.role && theme.role !== 'main' && !url.searchParams.has('preview_theme_id')) {
      url.searchParams.set('preview_theme_id', theme.id);
    }

    return url;
  }

  function refreshHref(link) {
    if (!link.hasAttribute('data-base-href')) link.setAttribute('data-base-href', link.getAttribute('href'));
    var url = buildUrl(link);
    if (url) link.setAttribute('href', url.toString());
    return url;
  }

  function cartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        return cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      })
      .catch(function () {
        return 0;
      });
  }

  function init() {
    document.querySelectorAll('a[data-brand-switch]').forEach(refreshHref);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-brand-switch]');
    if (!link) return;

    var url = refreshHref(link);
    if (!url) return;

    // The theme editor preview cannot follow a link to another domain.
    if (window.Shopify && window.Shopify.designMode) {
      event.preventDefault();
      return;
    }

    // Let the browser handle new-tab / new-window clicks with the refreshed href.
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var notice = link.getAttribute('data-cart-notice');
    if (!notice) return;

    event.preventDefault();
    cartCount().then(function (count) {
      if (count > 0 && !window.confirm(notice.replace('[count]', count))) return;
      window.location.assign(url.toString());
    });
  });

  // Disabled preview-only controls never navigate.
  document.addEventListener('click', function (event) {
    var disabled = event.target.closest && event.target.closest('.brand-switch--disabled');
    if (disabled) event.preventDefault();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
